import React from 'react';

import BoxIcon from '../../../assets/icons/box-right-icon.svg';

import { PoCardItemDetailsWrapper } from './style';
import { Tooltip } from 'antd';

const PoCardItemDetails = ({
  productImage,
  onClick,
  cardClick,
  productTitle,
  identifierType,
  identifierValue,
  invoiceQty,
  receivedQty,
  brand,
  status
}) => {

  return (
    <PoCardItemDetailsWrapper onClick={cardClick} style={status?.toLowerCase() === 'confirmed' ? { opacity: '0.7' } : null}>
      <img className='product-img' src={productImage} title='Product Image' alt='Product Image' />
      <div className='title-item'>
        <div className='content-title'>
          <Tooltip title={productTitle.length > 20 ? productTitle : null}>
          <p>{productTitle}</p>
          </Tooltip>
          <img onClick={onClick} src={BoxIcon} title='Box Icon' alt='Box Icon' />
        </div>
        <div className='content-items'>
          <div className='items-wrapper'>
            <p>{identifierType?.toUpperCase()}:</p>
            <p>{identifierValue}</p>
          </div>
          <div className='items-wrapper'>
          <p>Brand:</p>
          <Tooltip title={brand.length > 20 ? brand : null}>
          <p className='brand-text-wrapper'>{brand}</p>
          </Tooltip>
          </div>
        </div>
        <div className='content-items'>
        <div className='items-wrapper'>
          <p>Invoice Qty:</p>
          <p>{invoiceQty}</p>
          </div>
          <div className='items-wrapper'>
            <p>Received Qty:</p>
            <p>{receivedQty}</p>
          </div>
        </div>
      </div>
    </PoCardItemDetailsWrapper >
  );
};

export default PoCardItemDetails;
